import script from "./ConnectionBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectionBanner.vue?vue&type=script&setup=true&lang=js"

import "./ConnectionBanner.vue?vue&type=style&index=0&id=1ca035d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca035d8"]])

export default __exports__